import * as Sentry from "@sentry/react";

/**
 * Opens the native share sheet and handles the returned promise.
 * An AbortError just means the user dismissed the share sheet, so it is ignored.
 * Any other failure is reported to Sentry and, when provided, the
 * fallback text is copied to the clipboard instead.
 */
export const shareLink = async (data, fallbackText) => {
  try {
    await navigator.share(data);
    return true;
  } catch (err) {
    if (err?.name === "AbortError") {
      return false;
    }
    Sentry.captureException(err, { extra: { shareData: data } });
    if (fallbackText && navigator.clipboard) {
      try {
        await navigator.clipboard.writeText(fallbackText);
      } catch (clipboardErr) {
        Sentry.captureException(clipboardErr);
      }
    }
    return false;
  }
};
